/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './appealActionedSubject.defs'
export { main as default } from './appealActionedSubject.defs'
